import { useState } from 'react'
import { styled } from '@mui/material'
import {
  Box,
  IconButton,
  Stack,
  Typography,
} from '@elphasecure/elpha-design-system'
import { ArrowSmall, ArrowSmallNoCircle, Union } from '../../assets/svgs'
import Thumbprint from '../../assets/svgs/Thumbprint.png'
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle'

interface ThemedDialogTitleProps extends DialogTitleProps {
  onClose?: any
  handleChange?: any
  description?: String
  backActionDescription?: String
  titleVariant?: string
}

const ThemedDialogTitle = styled(DialogTitle)<DialogTitleProps>(
  ({ theme }) => ({
    position: 'relative',
    padding: '2rem 4rem',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary[600],
  })
)

const DialogTitleWrapper = ({
  title,
  onClose,
  handleChange,
  description,
  backActionDescription,
  titleVariant,
  ...props
}: ThemedDialogTitleProps) => {
  const [parentHover, setParentHover] = useState(false)

  return (
    <ThemedDialogTitle
      {...props}
      sx={{ paddingBottom: description ? '8.8rem' : '' }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: '0.3',
          backgroundImage: `url(${Thumbprint}) `,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background:
            'linear-gradient(270deg, #191933 8.78%, rgba(25, 25, 51, 0) 100%)',
        }}
      />

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction={'row'} sx={{ alignItems: 'flex-start' }}>
          {handleChange && (
            <Stack
              direction={'row'}
              sx={{ alignItems: 'center', marginRight: '2.4rem' }}
            >
              <Box
                onMouseOver={() => setParentHover(true)}
                onMouseOut={() => setParentHover(false)}
                onClick={(e) => handleChange(e, 0)}
                sx={{
                  height: '3.2rem',
                  color: 'white.main',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  position: 'relative',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                    borderRadius: '999',
                  },
                }}
              >
                {parentHover ? <ArrowSmallNoCircle /> : <ArrowSmall />}
              </Box>
              {backActionDescription && (
                <Typography
                  sx={{
                    paddingLeft: '1.2rem',
                    color: 'white.main',
                  }}
                >
                  {backActionDescription}
                </Typography>
              )}
            </Stack>
          )}
          <Stack direction={'column'}>
            <Typography
              variant={(titleVariant as any) || 'headlineMedium'}
              sx={{ zIndex: 9999 }}
            >
              {title}
            </Typography>
            {description && (
              <Typography
                variant="bodyMedium"
                sx={{
                  color: 'primary.300',
                  position: 'absolute',
                  marginTop: '3rem',
                  paddingRight: '4.0rem',
                }}
              >
                {description}
              </Typography>
            )}
          </Stack>
        </Stack>
        {onClose && (
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              width: '2.6rem',
              height: '2.6rem',
              color: 'rgba(255,255,255,0.4)',
              border: '2px',
              borderStyle: 'solid',
              borderColor: 'common.white',
              borderRadius: '0.7rem',
              minWidth: 0,
              '&:hover': {
                borderColor: 'primary.main',
                backgroundColor: 'primary.main',
                color: 'common.white',
              },
            }}
          >
            <Union />
          </IconButton>
        )}
      </Stack>
    </ThemedDialogTitle>
  )
}

export default DialogTitleWrapper
